import { api } from "@/lib/api";
import { PaginationMeta } from "@/types/appointment.api.types";

export interface CreateVehiclePayload {
  type?: string;
  plateNumber: string;
  color?: string;
  modelId?: string;
  makeId?: string;
  customerId: string;
  year?: number;
}

export interface UpdateVehiclePayload {
  type?: string;
  plateNumber: string;
  color?: string;
  notes?: string | null;
  makeId?: string;
  modelId?: string;
  year?: number;
}

export interface VehicleQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: "plateNumber" | "make" | "model" | "year" | "createdAt";
  sortOrder?: "asc" | "desc";
}

export interface VehiclePaginatedResponse {
  success: boolean;
  data: any[];
  message?: string;
  pagination: PaginationMeta;
}

export const vehicleService = {
  async createVehicle(payload: CreateVehiclePayload) {
    const response = await api.post("/vehicle", payload);
    return response.data.data;
  },

  async getAllVehicles() {
    const response = await api.get("/vehicle");
    return response.data.data;
  },

  async getVehiclesPaginated(params?: VehicleQueryParams) {
    const response = await api.get<VehiclePaginatedResponse>("/vehicle/paginated", {
      params,
    });
    return {
      data: response.data.data,
      pagination: response.data.pagination,
      success: response.data.success,
    };
  },

  async updateVehicle(id: string, payload: UpdateVehiclePayload) {
    const response = await api.put(`/vehicle/${id}`, payload);
    return response.data.data;
  },

  async deleteVehicle(id: string) {
    const response = await api.delete(`/vehicle/${id}`);
    return response.data.data;
  },
};
